export const FOCUS_ACCESS_EVENT = 'io:focus-access-denied';

export function markFocusRequest(path, headers, pathname = window.location.pathname) {
  // This is an operational switch for the new UI, not a replacement for API authorization.
  if (/^\/focus(?:\/|$)/.test(pathname) && /^\/api\//.test(path) &&
      !/^\/api\/(?:focus\/access|user\/workspace|auth\/(?:session|logout)|csrf)(?:\/?(?:\?|$))/.test(path)) {
    headers.set('X-InboxOps-UI', 'focus');
  }
}

export function notifyFocusDenied(code) {
  if (code === 'focus_access_denied' && typeof window !== 'undefined') {
    window.dispatchEvent(new Event(FOCUS_ACCESS_EVENT));
  }
}
